<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="districtSelected"
        :clearable="!unclearable"
        :items="districtsSelected"
        :loading="districtsLoading"
        :search-input.sync="districtsSearch"
        item-text="name"
        item-value="id"
        :label="label ? label : $t('Shop.shopDistrict', [$consts.shopName()])"
        return-object
        v-bind="attrs"
        v-on="on"
        :error-messages="errorMessages"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="tree"
          :items="districts"
          :search="districtsSearch"
          :filter="districtsFilter"
          :active.sync="districtsSelected"
          item-key="id"
          item-children="districts"
          open-all
          hoverable
          activatable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import Districts from "@/api/districts";

export default {
  name: "SearcherDistrict",

  props: { value: Object, label: String, unclearable: Boolean, errorMessages: Array },

  computed: {
    districtsFilter() {
      return (item, search, textKey) =>
        this.districtSelected &&
        search == this.districtSelected.name
          ? true
          : item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getDistrictsFromAPI();
  },

  data: () => ({
    menu: false,
    tree: [],
    districts: [],
    districtsLoading: false,
    districtsSearch: "",
    districtsSelected: [],
    districtSelected: null,
  }),

  methods: {
    getDistrictsFromAPI() {
      this.districtsLoading = true;
      Districts.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.districts = response.data.districts;
            }
            this.districtsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.districtsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.districtsSelected = this.value ? [this.value] : [];
      },
    },
    districtsSelected: {
      immediate: true, //初始赋值也调用
      handler() {
        this.districtSelected =
          this.districtsSelected && this.districtsSelected[0]
            ? this.districtsSelected[0]
            : null;
      },
    },
    districtSelected: {
      handler() {
        this.districtsSelected = this.districtSelected
          ? [this.districtSelected]
          : [];
        this.$emit("input", this.districtSelected);
      },
    },
    districtsSearch: {
      handler() {
        if (!this.unclearable && !this.districtsSearch)
          this.districtsSelected = [];
      },
    },
  },
};
</script>
